import { AddDirectory } from '../types/state/AddDirectory';
import { State } from '../types/state/State';

export const addDirectoryStateSelector = (state: State): AddDirectory =>
  state.addDirectory;
